import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "@/modules/shared/ui/components/dialog"
import { Button } from "@/modules/shared/ui/components/button"

interface DeleteConfirmationDialogProps {
    open: boolean
    onOpenChange: (open: boolean) => void
    onConfirm: () => void
    title?: string
    description?: string
    isDeleting?: boolean
    confirmDisabled?: boolean
    disabledMessage?: string
    deleteButtonText?: string
    deleteButtonProcessingText?: string
}

export function DeleteConfirmationDialog({
    open,
    onOpenChange,
    onConfirm,
    title = "Are you sure?",
    description = "This action cannot be undone. This will permanently delete the selected item.",
    isDeleting = false,
    confirmDisabled = false,
    disabledMessage,
    deleteButtonText = "Delete",
    deleteButtonProcessingText = "Deleting...",
}: DeleteConfirmationDialogProps) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-[425px] bg-card">
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                    <DialogDescription className="text-muted-foreground mt-2">
                        {description}
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter className="mt-4 flex-col sm:flex-row gap-2">
                    {disabledMessage && confirmDisabled && (
                        <p className="text-xs text-red-500 w-full mb-2 sm:mb-0 sm:flex-1 flex items-center">
                            {disabledMessage}
                        </p>
                    )}
                    <div className="flex gap-2 justify-end w-full sm:w-auto">
                        <Button
                            variant="outline"
                            onClick={() => onOpenChange(false)}
                            disabled={isDeleting}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="destructive"
                            onClick={onConfirm}
                            disabled={isDeleting || confirmDisabled}
                            className={confirmDisabled ? 'opacity-50 cursor-not-allowed' : ''}
                        >
                            {isDeleting ? deleteButtonProcessingText : deleteButtonText}
                        </Button>
                    </div>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}
